/*
 * @Author: chengyunxiao
 * @Date: 2023-05-18 10:58:01
 * @LastEditTime: 2024-08-19 10:06:18
 * @Description: Do not eidt
 */

import type { StatAction } from '@/Enum/index';

interface Data {
  [key: string]: any;
}
/**
 * 获取当前环境状态 dev开发环境  test测试环境  release正式环境
 * @returns 返回当前
 */
export function getCurrentEnvMode(): string {
  // 获取当前环境属性 设置可能的值规范
  return process.env.VUE_APP_CURRENTMODE as env;
}

/**
 * 获取当前环境的状态判断
 * @returns 当前环境的判断
 */
export function getEnvStatus(): envObj {
  const env = getCurrentEnvMode();
  return {
    isDev: env === 'dev',
    isTest: env === 'test',
    isRelease: env === 'release',
  };
}

/**
 * 动态域名配置 注意资源引入 //s.thsi.cn/cd/ths-frontend-common-lib-container/v1.3.20/business/dynamicDomain.js
 * @param configUrl 需要切换备用域名的地址
 * @returns 切换之后的地址
 */
export function getUrlByPromise(configUrl: string): Promise<string> {
  return new Promise<string>(resolve => {
    if (getEnvStatus().isDev) {
      resolve(configUrl);
    } else {
      try {
        // 切换
        window.dynamicDomain.exchangeHost(configUrl, (url: string) => {
          url ? resolve(url) : resolve(configUrl);
        });
      } catch (error) {
        resolve(configUrl);
      }
    }
  });
}

/**
 * 页面埋点
 * @param {string} field 埋点字段
 * @param {any} extra 额外字段
 */
export const sendStat = ({
  id,
  action,
  logmap,
}: {
  id: string;
  action: `${StatAction}`;
  logmap?: Record<string, unknown>;
}): void => {
  window.weblog.report({
    id,
    action,
    logmap,
  });
};

// hidden 事件属性
export const visibilityEventConfig = () => {
  let hiddenAttr = 'hidden';
  let visibilityChangeEvent = 'visibilitychange';
  const vendors = ['webkit', 'moz', 'ms'];
  const doc = document as any;
  // 匹配到兼容的属性名、事件名
  for (let v = 0; v < vendors.length && typeof doc[hiddenAttr] === 'undefined'; ++v) {
    hiddenAttr = `${vendors[v]}Hidden`;
    visibilityChangeEvent = `${vendors[v]}visibilitychange`;
  }
  return {
    visibilityChangeEvent,
    hiddenAttr,
  };
};

// 字符串下划线转驼峰
const formatToHump = (value: string) => value.replace(/_(\w)/g, (_, letter) => letter.toUpperCase());

/**
 * 数据对象key 驼峰下划线互相转化
 * @param {Object} formatedata 需要转换的对象
 */
export function formatHumpLineTransfer(formatedata: Data, flag = true): Data | string {
  if (!flag) {
    return formatedata;
  }
  let hump = '';
  // 转换对象中的每一个键值为驼峰的递归
  const formatTransferKey = (data: Data) => {
    if (Array.isArray(data)) {
      data.forEach(item => formatTransferKey(item));
    } else if (typeof data === 'object' && data !== null) {
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          hump = formatToHump(key);
          data[hump] = data[key];
          key !== hump && delete data[key];
          data[hump] instanceof Object && formatTransferKey(data[hump]);
        }
      }
    } else {
      return data;
    }
    return data;
  };
  return formatTransferKey(formatedata);
}

/*
 * skywalking 主动上报方法
 * @param category 类型
 * @param grade 级别
 * @param error Error 对象
 */
export const reportError = (
  error: Error | CustomError | unknown,
  category: ErrorCategory = 'js',
  grade: GradeType = 'Warning',
): void => {
  window.ClientMonitor
    && window.ClientMonitor.reportFrameErrors(
      {
        category,
        grade,
      },
      error,
    );
};

/**
 * 将对象的键由驼峰格式转换为下划线格式（递归处理所有层级）
 * @param {Object} obj 要转换的对象
 * @returns {Object} 转换后的对象
 */
export function convertKeysToUnderscore(obj: Data, flag = true): Data {
  if (!flag) {
    return obj;
  }
  if (typeof obj !== 'object' || obj === null) {
    // 处理非对象值
    return obj;
  }

  if (Array.isArray(obj)) {
    // 处理数组
    return obj.map(item => convertKeysToUnderscore(item));
  }

  // 处理对象
  const convertedObj = {};
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const convertedKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      convertedObj[convertedKey] = convertKeysToUnderscore(obj[key]);
    }
  }
  return convertedObj;
}

export const pxToVw = (number: number): string => {
  const size = 7.5;
  return `${number / size}vw`;
};

/**
 * 解析动态中心配置
 * @param data 返回数据
 * @param configKey 配置key
 * @returns
 */
export const analyzeDynamicConfig = async (
  data: { [key: string]: any },
  configKey: { [key: string]: string[] },
): Promise<{ [key: string]: any }> => {
  const result: { [key: string]: any } = {};
  for (const key in configKey) {
    // eslint-disable-next-line max-depth
    console.log(configKey)
    if (Object.prototype.hasOwnProperty.call(configKey, key)) {
      result[key] = {};
      configKey[key].forEach(item => {
        [result[key][item]] = data[key].filter(dataValue => dataValue.key === item);
      });
    }
  }

  return result;
};


/**
 * 获取平台类型
 * @returns 'iphone' | 'harmony' | 'gphone'
 */
export function getPlatform(): 'iphone' | 'harmony' | 'gphone' {
  const a = {
    versions: function() {
      const ua = navigator.userAgent;
      return {
        iPhone: ua.indexOf('iPhone') > -1 || ua.indexOf('Mac') > -1,
        iPad: ua.indexOf('iPad') > -1,
        HarmonyOS: ua.indexOf('HarmonyOS') > -1 || ua.indexOf('harmony') > -1 || ua.indexOf('Harmony') > -1
      };
    }(),
    language: ((navigator as any).browserLanguage || navigator.language).toLowerCase()
  };

  if (a.versions.iPhone || a.versions.iPad) {
    return 'iphone';
  } else if (a.versions.HarmonyOS) {
    return 'harmony';
  } else {
    return 'gphone';
  }
}
